import request from '@/utils/request/index.js'

// 用户
const userUrl = '/user-service/'
export const register = (params) => {
  return request({ url: userUrl + 'regist', method: 'post', data: params })
}

export const sendCode = (params) => {
  return request({url: userUrl + 'sendCode', method: 'post', data: params})
}

export const getUser = (params) => {
  return request({url: userUrl + 'getUser', method: 'post', data: params})
}

export const queryUser = (params) => {
  return request({url: userUrl + 'queryUser', method: 'post', data: params})
}

export const editUser = (params) => {
  return request({url: userUrl + 'editUser', method: 'post', data: params})
}

export const resetPassword = (params) => {
  return request({url: userUrl + 'resetPassword', method: 'post', data: params})
}

export const updateUserEmail = (params) => {
  return request({url: userUrl + 'updateUserEmail', method: 'post', data: params})
}

export const editUserStatus = (params) => {
  return request({url: userUrl + 'editUserStatus', method: 'post', data: params})
}

export const delUser = (params) => {
  return request({url: userUrl + 'delUser', method: 'post', data: params})
}

export const feedback = (params) => {
  return request({url: userUrl + 'feedback', method: 'post', data: params})
}

export const queryFeedback = (params) => {
  return request({url: userUrl + 'queryFeedback', method: 'post', data: params})
}

export const queryPromptPackageRecord = (params) => {
  return request({url: userUrl + 'queryPromptPackageRecord', method: 'post', data: params})
}

export const queryPromptUse = (params) => {
  return request({url: userUrl + 'queryPromptUse', method: 'post', data: params})
}

export const addUserVersion = (params) => {
  return request({url: userUrl + 'addUserVersion', method: 'post', data: params})
}

/** 查询用户会员版本段（管理端赠送时展示同版本已有区间） */
export const queryUserVersion = (params) => {
  return request({url: userUrl + 'queryUserVersion', method: 'post', data: params})
}

export const updateUserPromptCount = (params) => {
  return request({url: userUrl + 'updateUserPromptCount', method: 'post', data: params})
}

export const sendMessage = (params) => {
  return request({url: userUrl + 'sendMessage', method: 'post', data: params})
}

export const queryVersionConfig = (params) => {
  return request({url: userUrl + 'queryVersionConfig', method: 'post', data: params})
}

export const editVersionConfig = (params) => {
  return request({url: userUrl + 'editVersionConfig', method: 'post', data: params})
}

export const getCountryByIp = (params) => {
  return request({url: userUrl + 'getCountryByIp', method: 'post', data: params})
}

export const checkUserRegister = (params) => {
  return request({url: userUrl + 'checkUserRegister', method: 'post', data: params})
}

export const editInvoice = (params) => {
  return request({ url: userUrl + 'editInvoice', method: 'post', data: params })
}

export const queryInvoice = (params) => {
  return request({ url: userUrl + 'queryInvoice', method: 'post', data: params })
}

export const getInvoice = (params) => {
  return request({ url: userUrl + 'getInvoice', method: 'post', data: params })
}

export const delInvoice = (params) => {
  return request({ url: userUrl + 'delInvoice', method: 'post', data: params })
}

export const querySysTimeZone = (params) => {
  return request({ url: userUrl + 'querySysTimeZone', method: 'post', data: params })
}
